var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61623 2.045C6.38189 2.27941 6.25024 2.59729 6.25024 2.92875C6.25024 3.2602 6.38189 3.57809 6.61623 3.8125L12.8037 10L6.61623 16.1875C6.38853 16.4233 6.26254 16.739 6.26538 17.0668C6.26823 17.3945 6.39969 17.708 6.63145 17.9398C6.86321 18.1715 7.17673 18.303 7.50448 18.3058C7.83222 18.3087 8.14797 18.1827 8.38373 17.955L15.455 10.8837C15.6893 10.6493 15.821 10.3315 15.821 10C15.821 9.66854 15.6893 9.35066 15.455 9.11625L8.38373 2.045C8.14932 1.81066 7.83143 1.67902 7.49998 1.67902C7.16852 1.67902 6.85064 1.81066 6.61623 2.045Z",
    fill: "#FF5B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.bd84caa6d6d5c7b20b1d969d36924ef9.svg";
export { ForwardRef as ReactComponent };